import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = { class: "catalog catalog--layout-single-item" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_CircularSpinner = _resolveComponent("CircularSpinner");
    const _component_CatalogItem = _resolveComponent("CatalogItem");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.loadingProducts)
            ? (_openBlock(), _createBlock(_component_CircularSpinner, {
                key: 0,
                size: 25
            }))
            : (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: _normalizeClass(["catalog__items products", `columns-${_ctx.config.columns}`])
            }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.products, (p, i) => {
                    return (_openBlock(), _createBlock(_component_CatalogItem, {
                        key: `product-${p.id}`,
                        host: _ctx.config.baseUrl,
                        product: p,
                        lang: _ctx.config.language,
                        "tax-applier": _ctx.taxApplier,
                        "show-add-to-cart-btn": _ctx.config.showAddToCartBtn,
                        "show-quantity-input": _ctx.config.showQuantityInput,
                        onAddToCart: ($event) => (_ctx.addToCartHandle($event, i)),
                        onViewDetails: ($event) => (_ctx.viewDetailsHandle($event, i)),
                        onAddToWishlist: ($event) => (_ctx.addToWishlistHandle($event, i))
                    }, null, 8 /* PROPS */, ["host", "product", "lang", "tax-applier", "show-add-to-cart-btn", "show-quantity-input", "onAddToCart", "onViewDetails", "onAddToWishlist"]));
                }), 128 /* KEYED_FRAGMENT */))
            ], 2 /* CLASS */))
    ]));
}
